var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarikradio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 180,
    height: 180,
    viewBox: "0 0 144 53",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#171045;}\n\t.st2{fill:#F0494C;}\n\t.st3{fill:#F0494B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.5,1.3 61.7,14.4 61.7,38.4 82.3,50.3 101.4,39.8 102.6,35.1 101.4,14.4  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000155109689702359583830000010914269496432232885_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.4,33.1c-2.8,0-4.9-2.2-4.9-5c0-2.9,2.1-5,4.9-5c2.8,0,4.9,2.1,4.9,5S46.2,33.1,43.4,33.1L43.4,33.1z  M49.8,17.1L49,18.8c-1.9-1.6-4.3-2.4-6.7-2.4c-6.7,0-11.5,4.8-11.5,11.6s4.8,11.7,11.5,11.7c2.4,0,4.7-0.8,6.6-2.3l0.7,1.5h5.9 v-22L49.8,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.5,33.1c-2.8,0-4.9-2.2-4.9-5s2.1-5,4.9-5s4.9,2.2,4.9,5C21.4,31,19.4,33.1,16.5,33.1z M20.9,9.2v8.7 c-1.6-1-3.5-1.5-5.4-1.5C8.8,16.4,4,21.3,4,28.1s4.8,11.7,11.5,11.7c2.4,0,4.8-0.8,6.6-2.4l0.7,1.6h5.6V11.3L20.9,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.6,39h7.6V17h-7.6V39z M107.6,14.4h7.5V10l-7.5-2V14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.2,39l-7.6-11.4l5.6-8.5l-7.1-2l-5.3,8.6V11.3l-7.6-2.1V39h7.6v-9.3l4.8,8c0.2,0.4,0.5,0.7,0.9,0.9 s0.8,0.3,1.2,0.3L140.2,39L140.2,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.1,10.5l-2.2-1.3l-3.8,2.2l2.2,1.3c0.6,0.4,1.3,0.6,2,0.6s1.4-0.1,2.1-0.5C87.4,12.2,87.5,11.3,86.1,10.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.3,27.6l-2.2-1.3v4.4l2.2,1.3c1.4,0.8,2.1,0.3,2.1-1c0-0.7-0.2-1.4-0.6-2C71.5,28.4,71,27.9,70.3,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.5,27.3l-2.2,1.3V33l2.2-1.3c0.6-0.3,1.1-0.8,1.5-1.4s0.6-1.3,0.6-2C95.7,26.9,94.9,26.5,93.5,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96,41.3l-2.9-4.6l-1.8,1v6.2l-4.9,2.8l-0.1-20.4l7.7-4.4c3.8-2.2,6.6-0.9,6.6,3.4c0,2.5-1,5.2-2.8,7.4 l3.5,5.4L96,41.3z M83.5,17l-3,5.8l-5.4-3.1l2.6-4.8l-1.8-1L70.5,17l-4.9-2.8L83.4,3.9L91,8.3c3.8,2.2,4,5.3,0.3,7.4 C89.1,17,86.3,17.4,83.5,17z M72.8,44.4l-2.9-7.9l-1.8-1v6.2l-4.9-2.8l-0.1-20.4l7.6,4.4c3.8,2.2,6.6,6.8,6.6,11 c0,2.5-1,3.9-2.8,4.1l3.5,9.5L72.8,44.4z M100.6,11.2L85.4,2.4c-1.2-0.7-2.5-1-3.9-1s-2.7,0.4-3.9,1l-15.3,8.8 c-1.2,0.7-2.1,1.7-2.8,2.8c-0.7,1.2-1,2.5-1,3.9v17.6c0,1.4,0.4,2.7,1,3.9c0.7,1.2,1.7,2.2,2.8,2.8L77.6,51c1.2,0.7,2.5,1,3.9,1 s2.7-0.4,3.9-1l15.2-8.8c1.2-0.7,2.1-1.7,2.8-2.8c0.7-1.2,1-2.5,1-3.9V17.9c0-1.4-0.4-2.7-1-3.9S101.8,11.8,100.6,11.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarikradio);
export default __webpack_public_path__ + "static/media/darikradio.5a8f21afd12b16b275954299068be6fc.svg";
export { ForwardRef as ReactComponent };